import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * BeeSafeHtml pipe, sanitizes the html.
 */
@Pipe({name: 'beeSafeHtml'})
export class BeeSafeHtmlPipe implements PipeTransform {
  /**
   * Constructor.
   * @param sanitized
   */
  constructor(private sanitized: DomSanitizer) {
  }

  /**
   * Pipe transform.
   * @param value
   */
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
